import React from "react";
import MultiSelect from "react-multi-select-component";
import { FormControl } from "../../compat/BootstrapCompat";

export default function StepOne(props){
  const inputValues = props.inputValues;

  let classNames = require('classnames');
  let rowClass = classNames({
    'row': !props.mobile,
    'row no-margin': props.mobile
  });

  const ArrowRenderer = () => <>{ <span className='panel-dropdown-icon carat-down' aria-hidden='true'></span>}</>;
  return(
    <React.Fragment>
      <div className="step-breadcrumb hmcw-h5">Step 1 of 3</div>
      <div className="flex-justified padding-30-0">
        <span className="hmcw-h3">Tell me about your business</span>
        <div className="align-self-center body"><span className="red-text">*</span> Indicates a mandatory field</div>
      </div>

      <div className={rowClass}>
        <div className="form-group no-top-btm-margin">
          <div className="col-sm-6 wizard-form-text">
            <label htmlFor="employeeCount" className="body-semibold">Number of employees requiring RP Data <span className="red-text">*</span></label>
            <FormControl
              className={ inputValues.employeeCount.error ? 'form-error-border wizard-select' : 'wizard-select'}
              name="employeeCount"
              componentClass="select"
              value={inputValues.employeeCount.value === null ? "" : inputValues.employeeCount.value}
              onChange={props.handleChange}>
              <option value="">--Please Select--</option>
              <option value="1">1 user</option>
              <option value="3">2-3 users</option>
              <option value="5">4-5 users</option>
              <option value="10">6-10 users</option>
              <option value="15">11-15 users</option>
              <option value="25">16-25 users</option>
            </FormControl>
            <span className='panel-dropdown-icon carat-down single-select-carat' aria-hidden='true'></span>
            {
              inputValues.employeeCount.error &&
              <div className="red-text footnote-text hmcw-error-msg">Please select the employee count.</div>
            }
          </div>
          <div className="col-sm-6 wizard-form-text">
            <label htmlFor="geography" className="body-semibold">States/Territories that you service <span className="red-text">*</span></label>

            <MultiSelect
              className={ inputValues.geography.error ? 'form-error-border wizard-multiselect body' : 'wizard-multiselect body' }
              name="geography"
              options={props.geographyOptions}
              value={inputValues.geography.value}
              ArrowRenderer={ArrowRenderer}

              onChange={(e)=> {
                /*istanbul ignore next*/
                props.handleChange(e, "geography")
              }}
            />
            {
              inputValues.geography.error &&
              <div className="red-text footnote-text hmcw-error-msg">Please select the state/territories.</div>
            }
          </div>
        </div>
      </div>

      <div className={rowClass}>
        <div className="form-group no-top-btm-margin">
          <div className="col-sm-6 wizard-form-text">
            <label htmlFor="industry" className="body-semibold">Industry</label>
            <FormControl
              name="industry"
              componentClass="select"
              className='body wizard-select'
              value={inputValues.industry.value === null ? "" : inputValues.industry.value}
              onChange={props.handleChange}>
              <option value="null">--Please Select--</option>
              <option>Residential Real Estate</option>
              <option>Commercial Real Estate</option>
              <option>Valuer</option>
            </FormControl>
            <span className='panel-dropdown-icon carat-down single-select-carat' aria-hidden='true'></span>
          </div>
          <div className="col-sm-6 wizard-form-text">
            <label htmlFor="salesRange" className='body-semibold'>Typical Number of sales in a calendar year</label>
            <FormControl
              name="salesRange"
              componentClass="select"
              className='body wizard-select'
              value={inputValues.salesRange.value === null ? "" : inputValues.salesRange.value}
              onChange={props.handleChange}>
              <option value="null">--Please Select--</option>
              <option>1-10</option>
              <option>10-20</option>
              <option>20-50</option>
              <option>50-100</option>
              <option>100-500</option>
              <option>500+</option>
            </FormControl>
            <span className='panel-dropdown-icon carat-down single-select-carat' aria-hidden='true'></span>
          </div>
        </div>
      </div>

      <div className={rowClass}>
        <div className="form-group no-top-btm-margin">
          <div className="col-sm-6 wizard-form-text">
            <label htmlFor="propertiesRange" className='body-semibold'>Number of properties under management</label>
            <FormControl
              name="propertiesRange"
              componentClass="select"
              className='body wizard-select'
              value={inputValues.propertiesRange.value === null ? "" : inputValues.propertiesRange.value}
              onChange={props.handleChange}>
              <option value="null">--Please Select--</option>
              <option>1-10</option>
              <option>10-20</option>
              <option>20-50</option>
              <option>50-100</option>
              <option>100-500</option>
              <option>500-1000</option>
              <option>1000+</option>
            </FormControl>
            <span className='panel-dropdown-icon carat-down single-select-carat' aria-hidden='true'></span>
          </div>
          <div className="col-sm-6 wizard-form-text">
            <label htmlFor="problems" className="body-semibold">Biggest problem(s) you are trying to solve</label>
            <MultiSelect
              className="wizard-multiselect body"
              name="problems"
              options={props.problemsOptions}
              value={inputValues.problems.value}
              ArrowRenderer={ArrowRenderer}
              onChange={(e)=>{
                /*istanbul ignore next*/
                props.handleChange(e, "problems")
              }}
            />
          </div>
        </div>
      </div>

      {
        props.mobile &&
        <div className="margin-top-10">
          {
            inputValues.employeeCount.error &&
            <div className="red-text footnote-text">Please select the employee count.</div>
          }
          {
            inputValues.geography.error &&
            <div className="red-text footnote-text">Please select the state/territories.</div>
          }
        </div>
      }

    </React.Fragment>
  );

}
